export default __webpack_public_path__ + "static/media/cristiana-capotondi.c5f294e3.png";